'use strict';

import app from '../../../ngmodule';
import { ControllerBase } from '../../../control-base';

export class CardKpiController extends ControllerBase {
    public icon: string | undefined;
    public iconClass: string | undefined;
    public title: string | undefined;
    public value: string | undefined;

    static $inject = ['$element', '$timeout'];
    constructor(protected $element: ng.IRootElementService, protected $timeout: ng.ITimeoutService) {
        super();

        this.icon = undefined;
        this.iconClass = undefined;
    }

    $onInit(): void {
        if (this.icon == undefined) {
            this.icon = this.valueFromHtml("icon", '', this.$element);
        }

        if (this.iconClass == undefined) {
            this.iconClass = this.valueFromHtml("icon-class", 'success', this.$element);
        }

        if (this.title == undefined) {
            this.title = this.valueFromHtml("title", '', this.$element);
        }

        if (this.value == undefined) {
            this.value = this.valueFromHtml("value", '', this.$element);
        }
    }
}

app.component('vmCardKpi', {
    template: require('./template.html').default,
    transclude: true,
    bindings: {
        icon: '<',
        iconClass: '<',
        title: '<',
        value: '<'
    },    
    controller: CardKpiController
});